"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var spaui_utils_1 = require("@tencent/spaui-utils");

var info_1 = __importDefault(require("./info"));

var Link = function Link(props, ref) {
  var _a;

  var className = props.className,
      children = props.children,
      label = props.label,
      href = props.href,
      target = props.target,
      disabled = props.disabled,
      underline = props.underline,
      rel = props.rel,
      size = props.size,
      type = props.type,
      opacity = props.opacity,
      hoverLink = props.hoverLink,
      _b = props.as,
      Tag = _b === void 0 ? 'a' : _b,
      // eslint-disable-line
  restProps = __rest(props, ["className", "children", "label", "href", "target", "disabled", "underline", "rel", "size", "type", "opacity", "hoverLink", "as"]);

  return react_1["default"].createElement(Tag, __assign({}, restProps, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])('odc-link', (_a = {}, _a["odc-text-".concat(size)] = size, _a["odc-text-".concat(type)] = type, _a["opacity-".concat(opacity)] = opacity, _a['hover:odc-text-link'] = hoverLink, _a['cursor-pointer'] = !disabled, _a.underline = underline, _a)),
    supportAllEvents: true,
    ref: ref
  }, Link), {
    href: href,
    target: target,
    disabled: disabled,
    rel: rel
  }), children || label);
};

(0, spaui_utils_1.setComponentMark)(Link, info_1["default"]);
exports["default"] = react_1["default"].memo(react_1["default"].forwardRef(Link));